import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  queuePaper: {
    padding: '20px',
    width: '300px',
    margin: '10px',
    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)',
    fontFamily: 'Roboto',
    borderRadius: '5px',
    '& h1': {
      fontSize: '20px',
      fontWeight: 'bold',
      color: theme.palette.primary.main,
    },
    '& h2': {
      fontSize: '18px',
      fontWeight: 'bold',
      color: theme.palette.primary.main,
    },
  },
}));
